import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

import {EpiImage} from "features/search/types";
import {IContentBlock} from 'features/blocks/types';
import {ImageSizes} from '@organisms/Shell/image-size-enum';
import {isExternalUrl} from 'features/services/utils/url-helper';
import {HeadlineLevel, Margin, HeadlineSize, ParagraphSize} from 'features/ui/enums';
import {useDeviceStore, selectIsMobile, selectIsTablet} from 'features/ui/store/useDeviceStore';

import 'components/blocks/Headers/CampaignHeaderBlock/style.scss';

import {P} from '@atoms/Text/P';
import { Headline } from '@atoms/Text/Headline';
import {AsyncImage} from '@atoms/Media/AsyncImage';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

export interface CampaignHeaderBlockType {
    heroImage: EpiImage;
    title: string;
    preamble: string;
    buttonLink: string;
    buttonText: string;
    internalLink: boolean;

    lightText: boolean;
    noBg: boolean;
}

type Props = IContentBlock<CampaignHeaderBlockType>;

export const AlternativeCampaignBlock: React.FunctionComponent<Props> = (props) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);
    const noImg = !props.data.heroImage || props.data.heroImage === null;
    const noBg = true;

    const headerClasses = classnames('campaign-header-block campaign-header-block--narrow', {
        'campaign-header-block--no-image': noImg,
        'campaign-header-block--light-text dark-bg': (props.data.lightText && noBg),
        'campaign-header-block--no-bg': noBg,
    });

    return (
        <div className={headerClasses} id={props.id}>
            {!noImg &&
                <div className="campaign-header-block__image">
                    {isMobile ?
                        <div
                            className="campaign-header-block__image__wrapper"
                            style={{backgroundImage: props.data.heroImage ?
                                'url(' + props.data.heroImage.url + ')' :
                                ''}}
                        /> :
                        <div className="campaign-header-block__image__wrapper">
                            <AsyncImage
                                //alt={props.data.title}
                                fullWidth
                                headerImage
                                image={props.data.heroImage}
                                quality={ImageSizes.SIZE_2560}
                            />
                        </div>
                    }
                </div>
            }

            {props.data.title &&
                <div className="campaign-header-block__text">
                    <Headline 
                        level={HeadlineLevel.H1} 
                        size={HeadlineSize.L}
                        margin={isMobile && !isTablet ? Margin.S : undefined}
                    >
                        {props.data.title}
                    </Headline>

                    {props.data.preamble && props.data.preamble.length > 0 &&
                        <P
                            size={!isMobile ? ParagraphSize.L : undefined}
                        >
                            {props.data.preamble}
                        </P>
                    }

                    {props.data.buttonLink &&
                        <ButtonLink 
                            href={props.data.buttonLink} 
                            forceExternal={isExternalUrl(props.data.buttonLink)} 
                            buttonColor={ButtonColor.CTA} 
                            buttonSize={(!props.data.buttonText && noBg) 
                                ? ButtonSize.WIDE 
                                : ButtonSize.DEFAULT} 
                            buttonType={ButtonType.DEFAULT} 
                        >
                            {props.data.buttonText ?
                                props.data.buttonText :
                                <FormattedMessage id="jm.components.organisms.ctaHeaderBlock.readMore" />
                            }
                        </ButtonLink>
                    }
                </div>
            }
        </div>
    );
};
